"use client";

import { AnimatePresence } from "framer-motion";
import DefaultView from "./default-view";
import { WinnersSectionProps } from "../types/common";

type Props = {
  data: WinnersSectionProps;
};

export default function Winners({ data }: Props) {
  return (
    <>
      <AnimatePresence mode="wait">
        <DefaultView data={data} />
      </AnimatePresence>
    </>
  );
}
